import {
    GET_POS_ENTRY_MODE_SUCCESS,
    UPDATE_POS_ENTRY_MODE_SUCCESS,
    POS_ENTRY_MODE_API_ERROR,
  } from "./actionTypes";
  
  const INIT_STATE = {
    recordList: [], //Model Data ve Error
    error: {},
  };
  
  const PosEntryMode = (state = INIT_STATE, action) => {
    switch (action.type) {
      case GET_POS_ENTRY_MODE_SUCCESS:
        return {
          ...state,
          recordList: action.payload,
        };
  
      case UPDATE_POS_ENTRY_MODE_SUCCESS:
        return {
          ...state,
          recordList: state.recordList.map(record =>
            record.guid.toString() === action.payload.guid.toString()
              ? { record, ...action.payload }
              : record
          ),
        }
  
      case POS_ENTRY_MODE_API_ERROR:
        return {
          ...state,
          error: action.payload,
        };
  
      default:
        return state;
    }
  };
  
  export default PosEntryMode;
  